// handlersCallbacks.js
import { buildGroupBlock, buildTaskBlock } from './workflowBuilderHelpers';





 


/**
 * handleNodeDragStart:
 * - Speichert die aktuelle Position des Nodes in lastDragPositions.current[node.id].
 */
export function funcHandleNodeDragStart(event, node, lastDragPositions) {
  lastDragPositions.current[node.id] = node.position;
}

/**
 * handleNodeDrag:
 * - Berechnet das Delta (deltaX, deltaY) und aktualisiert 
 *   die Position des entsprechenden Blocks / Child-Blocks in staticJSON.
 */
export function funcHandleNodeDrag(event, node, lastDragPositions, setStaticJSON) {
  const { id, position } = node;
  const lastPos = lastDragPositions.current[id] || { x: position.x, y: position.y };
  const deltaX = (position.x - lastPos.x);
  const deltaY = (position.y - lastPos.y);
  lastDragPositions.current[id] = position;


  console.log("Moving: ",node)

  setStaticJSON((prev) => {
    if (!prev) return prev;

    const updated = JSON.parse(JSON.stringify(prev));  // tiefe Kopie
    const { blocks } = updated;

    // Hilfsfunktion: Verschiebt Node oder Child-Node um (dx, dy)
    const moveNodeInBlocks = (nodeId, dx, dy, blocksArr) => {
      for (let b of blocksArr) {
        // Top-level block?
        if (b.instance_id === nodeId) {
          console.log("found top lvl, ",b)
          if (!b.instance_pos) b.instance_pos = { x: 0, y: 0 };
          b.instance_pos.x += dx;
          b.instance_pos.y += dy;
          return true;
        }
        // Child?
        if (b.children_blocks && Array.isArray(b.children_blocks)) {
          for (let c of b.children_blocks) {
            const childFullId = `${b.instance_id}::${c.instance_id}`;
            if (childFullId === nodeId) {
              if (!c.instance_pos) c.instance_pos = { x: 0, y: 0 };
              c.instance_pos.x += dx;
              c.instance_pos.y += dy;
              return true;
            }
          }
        }
      }
      return false;
    };

    moveNodeInBlocks(id, deltaX, deltaY, blocks);
    return updated;
  });
}

/**
 * handleNodeDragStop:
 * - Ruft handleNodeDrag ein letztes Mal auf, um die finale Position zu speichern.
 */
export function funcHandleNodeDragStop(event, node, lastDragPositions, setStaticJSON) {
  const { id, position } = node;
  const lastPos = lastDragPositions.current[id] || { x: position.x, y: position.y };
  const deltaX = (position.x - lastPos.x);
  const deltaY = (position.y - lastPos.y);
  lastDragPositions.current[id] = position;

  setStaticJSON((prev) => {
    if (!prev) return prev;

    const updated = JSON.parse(JSON.stringify(prev));  // tiefe Kopie
    const { blocks } = updated;

    const moveNodeInBlocks = (nodeId, dx, dy, blocksArr) => {
      for (let b of blocksArr) {
        if (b.instance_id === nodeId) {
          if (!b.instance_pos) b.instance_pos = { x: 0, y: 0 };
          b.instance_pos.x += dx;
          b.instance_pos.y += dy;
          return true;
        }
        if (b.children_blocks && Array.isArray(b.children_blocks)) {
          for (let c of b.children_blocks) {
            const childFullId = `${b.instance_id}::${c.instance_id}`;
            if (childFullId === nodeId) {
              if (!c.instance_pos) c.instance_pos = { x: 0, y: 0 };
              c.instance_pos.x += dx;
              c.instance_pos.y += dy;
              return true;
            }
          }
        }
      }
      return false;
    };

    moveNodeInBlocks(id, deltaX, deltaY, blocks);
    return updated;
  });
}














/**
 * handleDeleteNode:
 * - Beispielhafter Code, wie man einen Node aus staticJSON entfernen könnte.
 *   Achtung: Hängt von Deiner Struktur ab – hier müsstest Du anpassen,
 *   wenn Du "blocks" / "children_blocks" statt "lvl1_blocks" verwendest.
 */
export function funcHandleDeleteNode(nodeId, parentId, staticJSON, setStaticJSON) {
  console.log("DELETE: ", nodeId, parentId, staticJSON);
  
  setStaticJSON((prev) => {
    if (!prev) return prev;

    // Kopie des aktuellen JSON-Objekts erstellen
    const updated = JSON.parse(JSON.stringify(prev));
    
    // Falls der gelöschte Node eine Child-Task ist
    if (parentId) {
      const parentBlock = updated.blocks.find(b => b.instance_id === parentId);
      if (parentBlock && parentBlock.children_blocks) {
        // Entferne die Task aus den children_blocks des Parents
        parentBlock.children_blocks = parentBlock.children_blocks.filter(b => b.instance_id !== nodeId);
      }
      // Entferne Verbindungen innerhalb children_connections
      if (parentBlock && parentBlock.children_connections) {
        parentBlock.children_connections = parentBlock.children_connections.filter(conn => conn.from !== nodeId && conn.to !== nodeId);
      }
    } else {
      // Falls es ein Hauptblock ist, entferne ihn aus blocks
      updated.blocks = updated.blocks.filter(b => b.instance_id !== nodeId);
      
      // Entferne Verbindungen in lvl1_connections
      updated.lvl1_connections = updated.lvl1_connections.filter(conn => conn.from !== nodeId && conn.to !== nodeId);
    }

    return updated;
  });
}


export function funcHandleEditBlock(
  blockId,
  parentBlockId,
  type,
  event,
  staticJSON,
  setEditPopup
) {
  console.log("Edit startet:", blockId, "Parent:", parentBlockId, "type: ", type);

  // Event-Koordinaten (Client oder Page, je nach Wunsch):
  const { x, y } = event;

  // 1) Top-Level-Block suchen
  let foundBlock = staticJSON.blocks.find((b) => b.instance_id === blockId);
  let blockType = foundBlock?.type; // z.B. "task" oder "group"

  // 2) Falls nicht gefunden => in child-Tasks (children_blocks) suchen:
  if (!foundBlock) {
    for (let b of staticJSON.blocks) {
      if (Array.isArray(b.children_blocks)) {
        let child = b.children_blocks.find((cb) => cb.instance_id === blockId);
        if (child) {
          foundBlock = child;
          blockType = "task"; // In children_blocks sind es meistens Tasks
          break;
        }
      }
    }
  }

  if (foundBlock) {
    setEditPopup({
      position: { x: x, y: y }, // Position des Maus-Klicks
      nodeData: foundBlock,
      nodeType: blockType, // "group" oder "task"
      parentId: parentBlockId || null,
    });
  } else {
    console.warn("Node zum Editieren nicht gefunden!");
  }
}









export function funcHandleEdgeClick(edge, staticJSON, setStaticJSON) {
  const { id, source, target } = edge;

  if (id.includes("::")) {
    const parentId = id.split("::")[0];
    const parentBlock = staticJSON.blocks.find(block => block.instance_id === parentId);
    if (parentBlock) {
      const updatedConnections = parentBlock.children_connections.filter(conn =>
        !(conn.from === source && conn.to === target)
      );

      setStaticJSON(prev => ({
        ...prev,
        blocks: prev.blocks.map(block =>
          block.instance_id === parentId ? { ...block, children_connections: updatedConnections } : block
        )
      }));
    }
  } else {
    const updatedConnections = staticJSON.lvl1_connections.filter(conn =>
      !(conn.from === source && conn.to === target)
    );

    setStaticJSON(prev => ({
      ...prev,
      lvl1_connections: updatedConnections
    }));
  }
}

export function funcCutChildrenEdges(childId, parentId, staticJSON, setStaticJSON) {
    console.log("childId:", childId, "parentId:", parentId, "staticJSON:", staticJSON);
  
    setStaticJSON((prev) => {
      if (!prev) return prev;
      // Deep Clone des aktuellen Zustands
      const updated = JSON.parse(JSON.stringify(prev));
  
      // Sicherstellen, dass updated.blocks ein Array ist
      if (updated.blocks && Array.isArray(updated.blocks)) {
        // Finde den Block, dessen instance_id dem parentId entspricht
        const parentBlock = updated.blocks.find(block => block.instance_id === parentId);
        if (parentBlock) {
          // Prüfen, ob children_connections existieren und ein Array sind
          if (parentBlock.children_connections && Array.isArray(parentBlock.children_connections)) {
            // Entferne alle Verbindungen, bei denen "from" gleich childId ist
            parentBlock.children_connections = parentBlock.children_connections.filter(
              conn => conn.from !== childId
            );
          } else {
            console.warn("children_connections sind nicht vorhanden oder kein Array im Block", parentId);
          }
        } else {
          console.warn("Kein Block mit instance_id", parentId, "gefunden.");
        }
      } else {
        console.warn("Blocks existieren nicht oder sind kein Array.");
      }
      
      return updated;
    });
  }
  


export function funcHandleConnection(currentEditingGroupId, connection_source, connection_target, setStaticJSON, staticJSON) {
    console.log("sourceNode ID:", connection_source);
    console.log("targetNode ID:", connection_target);

    const isChildConnection = connection_source.includes("::") && connection_target.includes("::");

    if (isChildConnection) {
        const parentIdSource = connection_source.split("::")[0];
        const parentIdTarget = connection_target.split("::")[0];

        const childIdSource = connection_source.split("::")[1];
        const childIdTarget = connection_target.split("::")[1];

        if (parentIdSource !== parentIdTarget) {
            alert("Verbindungen dürfen nur zwischen Elementen derselben Gruppe oder auf der obersten Ebene hergestellt werden.");
            return;
        }

        if (parentIdSource !== currentEditingGroupId) {
            alert("Gruppe muss im Edit mode sein, gruppe:", currentEditingGroupId, " parents: ", parentIdSource);
            return;
        }

        const parentNode = staticJSON.blocks.find(node => node.instance_id === parentIdSource);
        if (!parentNode) {
            console.warn("Eltern-Knoten nicht gefunden:", parentIdSource);
            return;
        }

        setStaticJSON((prev) => {
            if (!prev) return prev;
            const updated = JSON.parse(JSON.stringify(prev));
            const updatedParentNode = updated.blocks.find(node => node.instance_id === parentIdSource);
            if (!updatedParentNode) return prev;

            updatedParentNode.children_connections = updatedParentNode.children_connections || [];

            const alreadyExists = updatedParentNode.children_connections.some(conn => conn.from === childIdSource && conn.to === childIdTarget);
            if (alreadyExists) {
                console.warn("Verbindung zwischen", childIdSource, "und", childIdTarget, "besteht bereits!");
                return prev;
            }

            if (detectCycle(updatedParentNode.children_connections, childIdSource, childIdTarget)) {
                console.warn("Zyklische Verbindung erkannt zwischen", childIdSource, "und", childIdTarget, "! Verbindung nicht erlaubt.");
                alert("Keine Zyklischen Verbindungen möglich")
                return prev;
            }

            updatedParentNode.children_connections.push({ from: childIdSource, to: childIdTarget });

            return updated;
        });
    } else {
        const sourceHasParent = connection_source.includes("::");
        const targetHasParent = connection_target.includes("::");

        if (sourceHasParent || targetHasParent) {
            alert("Verbindungen zwischen Gruppen-Elementen und Top-Level-Elementen sind nicht erlaubt.");
            return;
        }

        setStaticJSON((prev) => {
            if (!prev) return prev;
            const updated = JSON.parse(JSON.stringify(prev));
            updated.lvl1_connections = updated.lvl1_connections || [];

            const alreadyExists = updated.lvl1_connections.some(conn => conn.from === connection_source && conn.to === connection_target);
            if (alreadyExists) {
                console.warn("Top-Level-Verbindung zwischen", connection_source, "und", connection_target, "besteht bereits!");
                return prev;
            }

            if (detectCycle(updated.lvl1_connections, connection_source, connection_target)) {
                console.warn("Zyklische Verbindung erkannt zwischen", connection_source, "und", connection_target, "! Verbindung nicht erlaubt.");
                alert("Keine Zyklischen Verbindungen möglich")
                return prev;
            }

            updated.lvl1_connections.push({ from: connection_source, to: connection_target });

            return updated;
        });
    }
}


// Funktion zur Erkennung von Zyklen im Graphen
function detectCycle(connections, source, target) {
    const graph = new Map();

    // Erstelle Adjazenzliste für den Graphen
    connections.forEach(({ from, to }) => {
        if (!graph.has(from)) graph.set(from, []);
        graph.get(from).push(to);
    });

    // **Zyklensuche per DFS**
    const visited = new Set();
    const stack = new Set();

    function dfs(node) {
        if (stack.has(node)) return true; // Zyklus gefunden
        if (visited.has(node)) return false;

        visited.add(node);
        stack.add(node);

        if (graph.has(node)) {
            for (const neighbor of graph.get(node)) {
                if (dfs(neighbor)) return true;
            }
        }

        stack.delete(node);
        return false;
    }

    // Verbindung im Graphen temporär hinzufügen und testen
    if (!graph.has(source)) graph.set(source, []);
    graph.get(source).push(target);

    return dfs(source);
}